import { useEffect, useState } from "react";
import { Monitor, Moon, Sun } from "lucide-react";

const CLAVE = "tukit_tema";
const CICLO = ["sistema", "claro", "oscuro"];
const ICONOS = { sistema: Monitor, claro: Sun, oscuro: Moon };
const NOMBRES = { sistema: "Tema del sistema", claro: "Tema claro", oscuro: "Tema oscuro" };

function aplicar(preferencia) {
  const oscuro =
    preferencia === "oscuro" ||
    (preferencia === "sistema" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.dataset.tema = oscuro ? "oscuro" : "claro";
}

/**
 * Tres estados en un solo botón, no un interruptor sol/luna.
 * "Sistema" es el valor por omisión y es el que la mayoría quiere: el
 * sitio sigue lo que ya eligió en su computadora.
 */
export default function Tema() {
  const [preferencia, setPreferencia] = useState("sistema");

  useEffect(() => {
    let guardada = "sistema";
    try {
      guardada = localStorage.getItem(CLAVE) ?? "sistema";
    } catch {
      /* almacenamiento bloqueado: se queda en "sistema" */
    }
    setPreferencia(guardada);

    // Si sigue al sistema, hay que reaccionar cuando el sistema cambie.
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const alCambiar = () => {
      if ((localStorage.getItem(CLAVE) ?? "sistema") === "sistema") aplicar("sistema");
    };
    mq.addEventListener("change", alCambiar);
    return () => mq.removeEventListener("change", alCambiar);
  }, []);

  function siguiente() {
    const p = CICLO[(CICLO.indexOf(preferencia) + 1) % CICLO.length];
    setPreferencia(p);
    aplicar(p);
    try {
      localStorage.setItem(CLAVE, p);
    } catch {
      /* sin almacenamiento: la elección dura esta sesión */
    }
  }

  const Icono = ICONOS[preferencia];

  return (
    <button
      type="button"
      onClick={siguiente}
      title={NOMBRES[preferencia]}
      aria-label={`${NOMBRES[preferencia]}. Pulsa para cambiar.`}
      className="texto-2 rounded-lg p-2 transition hover:bg-[color:var(--superficie-2)] hover:text-[color:var(--texto)] active:translate-y-px"
    >
      <Icono className="h-4 w-4" aria-hidden="true" />
    </button>
  );
}
